import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { PageLayout } from "@fidelix/fx-miranda";

import ManageNavbar from "./manage-nav-bar";
import { useCurrentUserQuery } from "../../user/user.queries";
import { isGlobalAdmin } from "../../helper";

export function ManageProtectedRoute() {
  const { data: currentUser, isFetched } = useCurrentUserQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (isFetched && !isGlobalAdmin(currentUser?.permissions)) {
      // if have no appropriate permission then redirect to root
      navigate("/");
    }
  }, [isFetched, currentUser, navigate]);

  if (!isFetched || !currentUser) {
    return null;
  }

  return (
    <PageLayout navbar={<ManageNavbar />}>
      <Outlet />
    </PageLayout>
  );
}
